<template>
  <div style="min-width: 100%">
    <h1 class="grey--text text--darken-2">Контакты</h1>

    <div class="mt-3 mb-3">
      <v-btn small :color="selectedItems.length ? 'red' : 'secondary'" :disabled="!selectedItems.length" @click="deleteAction()">
        <v-icon left dark>mdi-delete-circle-outline</v-icon> Удалить
      </v-btn>
      <v-btn small color="blue" dark @click="createAction" class="ml-3">
        <v-icon left dark>mdi-plus-circle-outline</v-icon> Создать
      </v-btn>
      <v-btn small color="yellow" @click="refreshAction" class="ml-3">
        <v-icon left dark>mdi-refresh</v-icon> Обновить
      </v-btn>
    </div>

    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="Поиск"
      single-line
      hide-details
      class="mb-3"/>

    <v-data-table
      v-model="selectedItems"
      :headers="headers"
      :items="items"
      :search="search"
      :loading="loading"
      item-key="contactID"
      disable-sort
      no-data-text="Контакты отсутствуют"
      show-select
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, -1],
        showFirstLastPage: true,
      }"
      dense
      class="elevation-1">
      <template v-slot:item.contactLName="{ item }">
        <span @click="editAction(item)" class="editable" style="cursor: pointer">{{ item.contactFName }} {{ item.contactMName }} {{ item.contactLName }}</span>
      </template>
      <template v-slot:item.contactEmail="{ item }">
        <a :href="'mailto:'+item.contactEmail" target="_blank">{{ item.contactEmail.length > 100 ? item.contactEmail.substr(0, 100) + '...' : item.contactEmail }}</a>
      </template>
      <template v-slot:item.contactPhone="{ item }">
        <span v-html="item.contactPhone.replace(/,/g, '<br>')"></span>
      </template>
      <template v-slot:item.companyName="{ item }">
        <router-link v-if="item.companyID" :to="'/companies/'+item.companyID">{{ item.companyName | truncate }}</router-link>
      </template>
    </v-data-table>
<!--
    <v-btn bottom color="pink" dark fab fixed right @click="createAction">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
-->
    <ContactsDialog ref="contactsDialog" @updated="load()"/>
  </div>
</template>

<script>
import api from '@/api'
import { combinedObject } from '@/common.js'

import ContactsDialog from '@/components/ContactsDialog.vue'

export default {
  components: { ContactsDialog },
  data: () => ({
    contact: {},
    loading: false,
    search: '',
    headers: [
      {
        text: 'Имя',
        value: 'contactLName',
      },
      {
        text: 'E-mail',
        value: 'contactEmail',
      },
      {
        text: 'Телефон',
        value: 'contactPhone',
      },
      {
        text: 'Компания',
        value: 'companyName',
      }
    ],
    items: [],
    selectedItems: []
  }),
  mounted: function () {
    this.load()
  },
  methods: {
    load () {
      this.loading = true;
      api.get('contacts/list').then(response => {
        this.loading = false;
        if ( response.data.$result !== 'ok' ) return this.$root.$alert(response.data.data, true)
        this.items = combinedObject(response.data.data.cols, response.data.data.rows);
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    },
    refreshAction () {
      this.load()
    },
    createAction () {
      this.$refs.contactsDialog.create()
    },
    editAction (item) {
      this.$refs.contactsDialog.edit(item)
    },
    deleteAction () {
      if ( !this.selectedItems.length || !confirm('Удалить отмеченные контакты ('+this.selectedItems.length+') ?') ) return
      let del = this.selectedItems.reduce((acc, cur, idx) => (acc[idx] = cur.contactID, acc), [])
      this.loading = true
      api.post('contacts/delete', {delete: del}).then(response => {
        this.loading = false
        if ( response.data.$result !== 'ok' ) return this.$root.$alert(response.data.data, true)
        this.$root.$alert('Удалено контактов: '+response.data.data.affected)
        this.selectedItems.length = 0;
        this.load()
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    }
  },
  filters: {
    truncate (v) { return v.length > 80 ? v.substr(0, 80)+'...' : v }
  }
}
</script>

<style scoped>
.editable:hover { color: #08A2B8; border-bottom: 1px #08A2B8 dashed; }
</style>
